import axios from 'axios';
import get from 'lodash/get';
import { notification } from 'antd';
import { LOGOUT } from '../constants/routes';

const configureAxios = () =>
    axios.create({
        baseURL: process.env.REACT_APP_BASE_URL,
        timeout: 250000
    });

const axiosInstance = configureAxios();

axiosInstance.interceptors.request.use((config) => config);

axiosInstance.interceptors.response.use(
    (response) => response.data,
    (err) => {
        if(!get(err, 'response')){
            notification.error({
                message: "Something Went Wrong !",
                className: 'error-notification',
                description: "Please contact the technical Team",
            })
        } else{
            notification.error({
                message: get(err, 'response.data.message'),
                className: 'error-notification',
            })

            if(get(err, 'response.status') === 403){
                window.location.replace(LOGOUT);
            }
        }
        return Promise.reject(err);
    }
);

export default axiosInstance;